import Vue from 'vue'
import App from './App.vue'
import { firestorePlugin } from 'vuefire'
import VueRouter from 'vue-router'
import VueCompositionApi from '@vue/composition-api'
// import { storage } from '../firebase';

Vue.use(VueCompositionApi)
Vue.use(VueRouter)
Vue.use(firestorePlugin)

Vue.config.productionTip = false

import Home from './components/Home'
import ChatRoom from './components/ChatRoom'
import ProfilePage from './components/ProfilePage'




const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    { path: '/chats/:id', component: ChatRoom, name: 'chat' },
    { path: '/profile/:uid', component: ProfilePage, name: 'profile'}
  ]
})

new Vue({
  router, 
  render: h => h(App),
}).$mount('#app')

// // Create a reference under which you want to list
// var listRef = storage.ref("pdf");

// // Find all the prefixes and items.
// listRef.listAll().then(function(res) {

//   res.items.forEach(function(itemRef) {
//     // All the items under listRef.
//     console.log(itemRef)
//     const p = document.createElement('a');
//     p.textContent = itemRef.location.path;
//     p.classList.add('col-lg-12');
//     // p.href = itemRef.getDownloadURL(); 
//     // console.log(p.href);
    

//     document.getElementById('bar').appendChild(p);
//     document.getElementById('bar').innerHTML+='<br />'

//   });
// });